// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__JMSTk","icon":"BackButton_icon__F9Ys8","iconClose":"BackButton_iconClose__Dm60x"};